import { Record, Union } from "./fable_modules/fable-library.4.10.0/Types.js";
import { record_type, string_type, union_type } from "./fable_modules/fable-library.4.10.0/Reflection.js";

export class Languages extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["English", "Russian", "Ukrainian", "Azerbaijanian", "Uzbek"];
    }
}

export function Languages_$reflection() {
    return union_type("L10n.Languages", [], Languages, () => [[], [], [], [], []]);
}

export class CommonL10n extends Record {
    constructor(Question, Answer, Comment$, PointsSmall, Team, QuizIsNotStarted, QuizIsNotFinished, MenuHistory, MenuQuestion, MenuResults, MenuLastCall) {
        super();
        this.Question = Question;
        this.Answer = Answer;
        this.Comment = Comment$;
        this.PointsSmall = PointsSmall;
        this.Team = Team;
        this.QuizIsNotStarted = QuizIsNotStarted;
        this.QuizIsNotFinished = QuizIsNotFinished;
        this.MenuHistory = MenuHistory;
        this.MenuQuestion = MenuQuestion;
        this.MenuResults = MenuResults;
        this.MenuLastCall = MenuLastCall;
    }
}

export function CommonL10n_$reflection() {
    return record_type("L10n.CommonL10n", [], CommonL10n, () => [["Question", string_type], ["Answer", string_type], ["Comment", string_type], ["PointsSmall", string_type], ["Team", string_type], ["QuizIsNotStarted", string_type], ["QuizIsNotFinished", string_type], ["MenuHistory", string_type], ["MenuQuestion", string_type], ["MenuResults", string_type], ["MenuLastCall", string_type]]);
}

export class TeamL10n extends Record {
    constructor(Common, NotActive, AnotherSession, UseThisDevice, YourAnswer, WaitingForConfirmation, RegistrationHasBeenRejected, Jeopardy, Question, Answer, Points, Vote, CorrectAnswer) {
        super();
        this.Common = Common;
        this.NotActive = NotActive;
        this.AnotherSession = AnotherSession;
        this.UseThisDevice = UseThisDevice;
        this.YourAnswer = YourAnswer;
        this.WaitingForConfirmation = WaitingForConfirmation;
        this.RegistrationHasBeenRejected = RegistrationHasBeenRejected;
        this.Jeopardy = Jeopardy;
        this.Question = Question;
        this.Answer = Answer;
        this.Points = Points;
        this.Vote = Vote;
        this.CorrectAnswer = CorrectAnswer;
    }
}

export function TeamL10n_$reflection() {
    return record_type("L10n.TeamL10n", [], TeamL10n, () => [["Common", CommonL10n_$reflection()], ["NotActive", string_type], ["AnotherSession", string_type], ["UseThisDevice", string_type], ["YourAnswer", string_type], ["WaitingForConfirmation", string_type], ["RegistrationHasBeenRejected", string_type], ["Jeopardy", string_type], ["Question", string_type], ["Answer", string_type], ["Points", string_type], ["Vote", string_type], ["CorrectAnswer", string_type]]);
}

export class AudienceL10n extends Record {
    constructor(Common, Audience, Question, CorrectAnswer, CorrectAnswers) {
        super();
        this.Common = Common;
        this.Audience = Audience;
        this.Question = Question;
        this.CorrectAnswer = CorrectAnswer;
        this.CorrectAnswers = CorrectAnswers;
    }
}

export function AudienceL10n_$reflection() {
    return record_type("L10n.AudienceL10n", [], AudienceL10n, () => [["Common", CommonL10n_$reflection()], ["Audience", string_type], ["Question", string_type], ["CorrectAnswer", string_type], ["CorrectAnswers", string_type]]);
}

export class RegL10n extends Record {
    constructor(Details, Procceed, Registration, Register, RegisteredAs, Status, Pending, Confirmed, Rejected, Edit, Enter, LinkForAudience, TeamName) {
        super();
        this.Details = Details;
        this.Procceed = Procceed;
        this.Registration = Registration;
        this.Register = Register;
        this.RegisteredAs = RegisteredAs;
        this.Status = Status;
        this.Pending = Pending;
        this.Confirmed = Confirmed;
        this.Rejected = Rejected;
        this.Edit = Edit;
        this.Enter = Enter;
        this.LinkForAudience = LinkForAudience;
        this.TeamName = TeamName;
    }
}

export function RegL10n_$reflection() {
    return record_type("L10n.RegL10n", [], RegL10n, () => [["Details", string_type], ["Procceed", string_type], ["Registration", string_type], ["Register", string_type], ["RegisteredAs", string_type], ["Status", string_type], ["Pending", string_type], ["Confirmed", string_type], ["Rejected", string_type], ["Edit", string_type], ["Enter", string_type], ["LinkForAudience", string_type], ["TeamName", string_type]]);
}

function l10n(lang, en, ru, ua, az, uz) {
    switch (lang.tag) {
        case 1:
            return ru;
        case 2:
            return ua;
        case 3:
            return az;
        case 4:
            return uz;
        default:
            return en;
    }
}

export function commonL10n(lang) {
    const Question = l10n(lang, "Question", "Вопрос", "Питання", "Sual", "Савол");
    const Answer = l10n(lang, "Answer", "Ответ", "Відповідь", "Cavab", "Жавоб");
    const Comment$ = l10n(lang, "Comment", "Комментарий", "Коментар", "Şərh", "Изоҳ");
    const PointsSmall = l10n(lang, "points", "очка", "очки", "xallar", "очко");
    const Team = l10n(lang, "Team", "Команда", "Команда", "Komanda", "Жамоа");
    const QuizIsNotStarted = l10n(lang, "Quiz is not started", "Квиз еще не начался", "Квіз ще не почався", "Oyun Başlamayıb", "Ўйин ҳали бошланмаган");
    const QuizIsNotFinished = l10n(lang, "Quiz is finished", "Квиз завершен", "Квіз завершено", "Oyun Bitdi", "Ўйин тугади");
    const MenuQuestion = l10n(lang, "Question", "Вопрос", "Питання", "Sual", "Савол");
    return new CommonL10n(Question, Answer, Comment$, PointsSmall, Team, QuizIsNotStarted, QuizIsNotFinished, l10n(lang, "History", "История", "Історія", "Cavablar", "Тарих"), MenuQuestion, l10n(lang, "Results", "Итоги", "Підсумки", "Nəticələr", "Натижалар"), l10n(lang, "Last Call", "Время", "Час", "Son saniyələr", "Вақт"));
}

export function teamL10n(lang) {
    return new TeamL10n(commonL10n(lang), l10n(lang, "NOT ACTIVE", "НЕАКТИВНО", "НЕ АКТИВНО", "AKTİV DEYİL", "ФАОЛ ЭМАС"), l10n(lang, "Team\'s session is running from another device. Only one device is allowed per team.", "Капитанская сессия запущена на другом устройстве. Допускается лишь одна активная сессия в команде.", "Капітанська сесія запущена на іншому пристрої. Допускається лише одна активна сесія в команді.", "Komanda kapitanlığı başqa cihazda aktivdir. Hər komanda üçün yalnız bir cihaza icazə verilir. Kapitanlığı qəbul etmək üçün Aktiv edin.", "Жамоа сардорининг ҳаволаси бошқа мосламада очилган. Ҳар жамоадан фақат битта фаол сессия бўлиши мумкин"), l10n(lang, "Activate", "Активировать", "Активувати", "Aktivləşdirin", "Фаоллаштириш"), l10n(lang, "Your answer", "Ваш ответ", "Ваша відповідь", "Sənin cavabın", "Жавобингиз"), l10n(lang, "Waiting for confirmation of the registration...", "Ожидается подтверждение регистрации...", "Очікується підтвердження реєстрації...", "Qeydiyyatınız təsdiq edilir...", "Рўйхатдан ўтганингиз тасдиқланмоқда"), l10n(lang, "Registration has been rejected (", "Регистрация была отклонена (", "Реєстрація була відхилена (", "Qeydiyyatınız rədd elildi (", "Рўйхатдан ўтиш рад этилди ("), l10n(lang, "Jeopardy!", "Рискую!", "Ризикую!", "Jeopardy!", "Таваккал!"), l10n(lang, "Question", "Вопрос", "Питання", "Sual", "Савол"), l10n(lang, "Answer", "Ответ", "Відповідь", "Cavab", "Жавоб"), l10n(lang, "Points", "Очки", "Очки", "Xal", "Очко"), l10n(lang, "Rate the question", "Оцените вопрос", "Оцініть питання", "Sualı qiymətləndirin", "Саволга баҳо беринг"), l10n(lang, "correct answer", "правильный ответ", "правильна відповідь", "doğru cavab", "Тўғри жавоб"));
}

export function audienceL10n(lang) {
    return new AudienceL10n(commonL10n(lang), l10n(lang, "audience", "зрители", "глядачі", "izləyici", "Муҳлисслар"), l10n(lang, "Question", "Вопрос", "Питання", "Sual", "Савол"), l10n(lang, "correct answer", "правильный ответ", "правильна відповідь", "doğru cavab", "Тўғри жавоб"), l10n(lang, "Correct answers", "Правильные ответы", "Правильні відповіді", "Doğru cavablar", "Тўғри жавоблар"));
}

export function regL10n(lang) {
    return new RegL10n(l10n(lang, "details", "подробности", "подробиці", "Ətraflı", "тафсилотлар"), l10n(lang, "Login to succeed registration", "Залогиньтесь для продолжения регистрации", "Залогіньтеся для продовження реєстрації", "Qeydiyyata Başla", "Рўйхатдан ўтишни давом эттириш учун ўз логинингизни киритинг"), l10n(lang, "registration", "регистрация", "реєстрація", "qeydiyyat", "Рўйхатдан ўтиш"), l10n(lang, "Register", "Зарегистрироваться", "Зареєструватися", "Qeydiyyatdan keçmək", "Рўйхатдан ўтиш"), l10n(lang, "registered as", "имя команды", "ім\'я команди", "komanda adı", "Жамоа номи"), l10n(lang, "status", "состояние", "стан", "nəticə", "статус"), l10n(lang, "pending", "ожидание", "очікування", "gözləyin", "кутиш"), l10n(lang, "confirmed", "ок", "ок", "uğurlu", "тасдиқлаш"), l10n(lang, "rejected", "отклонено", "відхилено", "uğrsuz", "қайтариш"), l10n(lang, "Edit", "Изменить", "Змінити", "Redaktə edin", "таҳрирлаш"), l10n(lang, "Enter", "Войти в", "Увійти в", "Redaktə edin", "Кириш"), l10n(lang, "for audience", "для зрителей", "для глядачів", "izləyicilər üçün", "муҳлисслар"), l10n(lang, "Team Name", "Имя команды", "Ім\'я команди", "Komanda adı", "Жамоанинг номи"));
}

